import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import TableCrudEnhanced from '../../components/TableCrudEnhanced';

const SectionIndex = () => {
    const navigate = useNavigate();

    // Configuração de filtros específica para SubSectionKPI
    const filterConfig = useMemo(() => [        
        {
            type: "text",
            name: "description",
            label: "Description",
            placeholder: "Description..."
        },
        {
            type: "text",
            name: "moduleDescription",
            label: "Module Description",
            placeholder: "Module Description..."
        },
        {
            type: "text",
            name: "operationDescription",
            label: "Operation Description",
            placeholder: "Operation Description..."
        }
    ], []);

    // Colunas da tabela
    const columns = useMemo(() => [
        {
            title: "Form",
            dataIndex: "module.operation.description",
            key: "module.operation.description",
            sortable: true 
        },
        {
            title: "Module",
            dataIndex: "module.description",
            key: "module.description",
            sortable: true 
        },
        { 
            title: 'Description', 
            dataIndex: 'description', 
            key: 'description', 
            sortable: true 
        },
        { 
            title: 'Order', 
            dataIndex: 'order', 
            key: 'order', 
            sortable: true 
        },        
        { 
            title: 'Active', 
            dataIndex: 'isActive', 
            key: 'isActive', 
            width: 80,
            render: (value, record, index, handleToggleActive) => (
                <span 
                    className={`badge ${value ? 'bg-success' : 'bg-secondary'}`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleToggleActive && handleToggleActive(record)}
                    title={`Click to ${value ? 'deactivate' : 'activate'}`}
                >
                    {value ? 'Active' : 'Inactive'}
                </span>
            )
        },
        { 
            title: 'Deleted', 
            dataIndex: 'isDeleted', 
            key: 'isDeleted', 
            width: 100,
            render: (value, record, index, handleToggleActive, handleToggleDeleted) => (
                <span 
                    className={`badge ${!value ? 'bg-success' : 'bg-secondary'}`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleToggleDeleted && handleToggleDeleted(record)}
                    title={`Click to ${!value ? 'delete' : 'restore'}`}
                >
                    {!value ? 'Not Deleted' : 'Deleted'}
                </span>
            )
        }
    ], []);

    // Actions
    const actions = useMemo(() => [
        {
            label: 'Edit',
            onClick: (record) => navigate(`/section/edit/${record.sectionID}`),
            type: 'primary'
        }
    ], [navigate]);

    return (
        <TableCrudEnhanced
            title="Section"
            apiEndpoint="/Section/getAllPaginated"
            toggleActiveEndpoint="/section/toggleActive"
            toggleDeletedEndpoint="/section/toggleDeleted"
            newRoute="/section/new"
            columns={columns}
            filterConfig={filterConfig}
            actions={actions}
            rowKey="sectionID"
            initialPageSize={10}
            enableFilters={true}
            showAddButton={true}
        />
    );
};

export default SectionIndex;
